import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { showToast } from "src/componentes";
import { showMessageBox } from "src/componentes/MessageBox/Messagebox";
import { MenuItemAction } from "src/pages/Privada/Menu/MenuItem.Dto";
import { TributacaoCfopImpostoExcluir } from "src/services/Fiscal.Service";

type Params = {
  id: string | null;
  setLoading: React.Dispatch<React.SetStateAction<boolean>>;
};

const TributacaoCfopImpostoIBSCBSCadastroMenu = (params: Params) => {
  const navigate = useNavigate();
  const [menuItens, setMenuItens] = useState<MenuItemAction[]>([]);

  const excluirImposto = () => {
    if (params.id) {
      showMessageBox(
        "Deseja realmente excluir o imposto IBS/CBS?",
        "Atenção!",
        "YesNo",
        "Warning",
        {
          onYes: Excluir,
        },
      );
    }
  };

  const Excluir = () => {
    params.setLoading(true);
    TributacaoCfopImpostoExcluir(Number(params.id))
      .then((response) => {
        if (response.data.success) {
          showToast({
            message: "Imposto IBS/CBS excluído com sucesso.",
            title: "Info",
            variant: "Info",
          });
          navigate(-1);
        } else {
          showToast({
            message: "Erro ao excluir o imposto IBS/CBS.",
            title: "Erro",
            variant: "Danger",
          });
        }
      })
      .finally(() => {
        params.setLoading(false);
      });
  };

  const menuPrincipal: MenuItemAction[] = [
    {
      id: 1,
      nome: "Excluir",
      rota: "",
      sequencia: 1,
      nivel: 1,
      idNivelAnterior: 0,
      action: excluirImposto,
    },
  ];

  useEffect(() => {
    const Load = async () => {
      if (params.id) {
        setMenuItens(menuPrincipal);
      }
    };
    Load();
  }, []);

  const handleMenuClick = (item: MenuItemAction) => (e: React.MouseEvent) => {
    if (item.children && item.children.length > 0) {
      e.stopPropagation();
      setMenuItens(item.children);
    } else if (item.action) {
      item.action();
    } else if (item.rota) {
      navigate(item.rota);
    }
  };

  return { menuItens, handleMenuClick };
};

export default TributacaoCfopImpostoIBSCBSCadastroMenu;
